import { useState } from 'react';
import './Artigo.css';

function Artigo() {
  const [modalAberto, setModalAberto] = useState(null);

  const artigos = [
    {
      id: 1,
      titulo: 'Programa Essence — Monitoramento Bioquímico e Correção de Micronutrientes Baseada em Evidências',
      resumo: 'A deficiência de micronutrientes é um dos fatores mais subestimados na origem de sintomas crônicos, disfunções metabólicas e queda de performance cognitiva.',
      conteudo: [
        'A deficiência de micronutrientes é um dos fatores mais subestimados na origem de sintomas crônicos, disfunções metabólicas, distúrbios de humor, queda de performance cognitiva e maior risco cardiovascular. O Programa Essence foi desenvolvido para abordar esse problema de maneira sistemática: monitorizar, interpretar e corrigir deficiências reais de forma contínua, segura e personalizada.',
        'Ao longo de 12 meses, o Essence realiza avaliações laboratoriais trimestrais, seguidas de prescrição e reposição injetável conforme necessidade bioquímica individual. Essa abordagem evita tanto a deficiência quanto o excesso de vitaminas e minerais, garantindo impacto clínico real, sem suplementação aleatória ou empírica.',
        'Impactos Clínicos da Correção de Micronutrientes',
        '1. Risco Cardiovascular e Metabolismo da Homocisteína',
        'A homocisteína elevada é um marcador independente de risco para AVC, doença coronariana, trombose e declínio cognitivo. Sua redução depende de cofatores essenciais, principalmente Vitamina B12, B6, B9 (metilfolato) e B2. A correção adequada diminui risco aterotrombótico, melhora metabolismo endotelial e exerce efeito protetor sobre o sistema nervoso.',
        '2. Regulação de Humor, Ansiedade e Comportamento Alimentar',
        'Evidências associam a deficiência de micronutrientes a alterações psiquiátricas. A Vitamina D modula vias dopaminérgicas e serotoninérgicas; o magnésio regula os receptores NMDA e GABA; as vitaminas B6 e B12 são essenciais para síntese de neurotransmissores. A correção é capaz de melhorar humor, qualidade do sono e reduzir compulsão alimentar.',
        '3. Imunidade e Inflamação Crônica de Baixo Grau',
        'Nutrientes como Zinco, Vitamina C, Vitamina D e Selênio modulam a resposta inflamatória, reduzem infecções recorrentes e controlam estresse oxidativo. O Selênio, especificamente, participa de enzimas antioxidantes como a glutationa-peroxidase, protegendo tecidos e reduzindo risco de tireoidopatias autoimunes.',
        '4. Função Cognitiva e Performance Cerebral',
        'Minerais e vitaminas são fundamentais para neurotransmissão, metabolismo energético cerebral e redução de neuroinflamação. Ferro, Vitamina B12 e B9 impactam diretamente a mielinização e oxigenação neuronal; magnésio e vitamina B6 modulam transmissão excitatória e inibitória. A deficiência crônica está associada a perda de memória, fadiga mental e baixa produtividade.',
        '5. Saúde Muscular, Óssea e Metabolismo Energético',
        'A combinação de Vitamina D, K2, magnésio e cálcio é determinante para saúde óssea e muscular, enquanto vitamina B12 e ferro influenciam oxigenação e capacidade física. Suas deficiências favorecem osteopenia, fraqueza, sarcopenia e fadiga persistente.',
        'Por que reposição injetável?',
        'A administração intramuscular ou intravenosa permite correção mais rápida, maior biodisponibilidade e bypass intestinal, sendo ideal para pacientes com gastrite, uso crônico de inibidores de bomba, síndrome do intestino irritável, pós-bariátricos, idosos ou pessoas com má absorção.',
        'Essência Clínica do Programa',
        'O Essence não "suplementa". Ele trata, previne e otimiza funções biológicas reais, baseando-se em biomarcadores laboratoriais periódicos. O objetivo é atuar nos pilares sistêmicos da saúde: humor, imunidade, performance cognitiva, metabolismo energético e risco cardiovascular, devolvendo ao paciente clareza mental, vitalidade e maior proteção metabólica em longo prazo.'
      ],
      autor: 'Dr. Marceu Lima',
      especialidade: 'Medicina Funcional Integrativa'
    },
    {
      id: 2,
      titulo: 'Emagrecimento com acompanhamento integrado',
      resumo: 'Emagrecer de forma saudável vai muito além da perda de peso. Envolve entender o corpo, equilibrar hormônios e ajustar hábitos.',
      conteudo: [
        'Emagrecer de forma saudável vai muito além da perda de peso. Envolve entender o corpo, equilibrar hormônios, ajustar hábitos e, principalmente, preservar a saúde durante todo o processo. Na Clínica Gerações, o tratamento do sobrepeso e da obesidade é conduzido dentro de um programa estruturado, que integra avaliação médica, acompanhamento nutricional e suporte psicológico.',
        'Nosso objetivo é promover uma mudança real e sustentável, respeitando o metabolismo e as particularidades de cada paciente.',
        'O acompanhamento médico garante o uso seguro e personalizado das terapias farmacológicas, com ajuste de doses e monitoramento contínuo dos resultados, evitando efeitos adversos e otimizando a resposta ao tratamento. Já o suporte nutricional é fundamental para ajustar a alimentação conforme as fases do emagrecimento e preservar a massa magra, prevenindo flacidez, fraqueza e efeito sanfona.',
        'O apoio psicológico atua no comportamento alimentar, na relação com a comida e na construção de novos hábitos — pilares essenciais para que o emagrecimento se mantenha ao longo do tempo.',
        'Durante todo o programa, o paciente passa por avaliações periódicas de composição corporal, com análise de gordura, massa magra e água corporal. Esse monitoramento permite identificar precocemente qualquer desequilíbrio e ajustar o plano terapêutico de forma precisa e individualizada.',
        'Na Clínica Gerações, o emagrecimento é um processo médico, funcional e humano. Mais do que reduzir números na balança, buscamos restaurar o equilíbrio metabólico, melhorar a vitalidade e fortalecer a saúde de dentro para fora.'
      ],
      autor: 'Dr. Marceu Lima',
      especialidade: 'Medicina Funcional Integrativa'
    }
  ];

  const abrirModal = (artigoId) => {
    setModalAberto(artigoId);
    document.body.style.overflow = 'hidden';
  };

  const fecharModal = () => {
    setModalAberto(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <section id="artigo" className="artigo-section">
      <div className="artigo-container">
        <h2>Artigos</h2>

        <div className="artigos-grid">
          {artigos.map((artigo) => (
            <div
              key={artigo.id}
              className="artigo-card"
              onClick={() => abrirModal(artigo.id)}
            >
              <h3 className="artigo-card-titulo">{artigo.titulo}</h3>
              <p className="artigo-card-resumo">{artigo.resumo}</p>
              <div className="artigo-card-footer">
                <div className="artigo-card-autor">
                  <span className="artigo-card-autor-nome">{artigo.autor}</span>
                  <span className="artigo-card-autor-esp">{artigo.especialidade}</span>
                </div>
                <span className="artigo-card-leia-mais">Leia mais →</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalAberto && (
        <div className="artigo-modal-overlay" onClick={fecharModal}>
          <div className="artigo-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="artigo-modal-fechar" onClick={fecharModal}>
              ✕
            </button>

            {artigos
              .filter((artigo) => artigo.id === modalAberto)
              .map((artigo) => (
                <div key={artigo.id} className="artigo-modal-body">
                  <h2 className="artigo-modal-titulo">{artigo.titulo}</h2>

                  <div className="artigo-modal-texto">
                    {artigo.conteudo.map((paragrafo, index) => (
                      <p key={index}>{paragrafo}</p>
                    ))}
                  </div>

                  <div className="artigo-modal-autor">
                    <p>{artigo.autor}</p>
                    <span>{artigo.especialidade}</span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </section>
  );
}

export default Artigo;
